import { ReplaySubject } from 'rxjs';
import { AppInitializerFactoryError } from '../../../factory/app-initializer.factory';

export class RsAppInitializerReplaySubject extends ReplaySubject<boolean> {
  public override error(err: AppInitializerFactoryError): void {
    super.error(err);
  }
}
